export default "https://backend-optibom.herokuapp.com/backend";
